<div class="modal-header" [attr.data-bs-theme]="darkModeService.darkModeSignal()">
    <h4 class="modal-title text-primary">Update account</h4>
    <i class="fa fa-2x fa-times text-primary" (click)="modalRef.hide()"></i>
  </div>
  <div class="modal-body" [attr.data-bs-theme]="darkModeService.darkModeSignal()">
    <form class="row g-3" [formGroup]="updateAccountForm">

      <div class="col-md-6">
        <label>Id</label>
        <input type="text" class="form-control" formControlName="id">
      </div>

      <div class="col-md-18">
        <label>Name</label>
        <input type="text" class="form-control" formControlName="name">
      </div>

      <div class="col-md-24">
        <label>Email addresses</label>
        <input type="text" class="form-control" formControlName="emailAddresses">
      </div>

      <div class="col-md-24">
        <label>Report email addresses</label>
        <input type="text" class="form-control" formControlName="reportEmailAddresses">
      </div>

    </form>
  </div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="modalRef.hide()">Cancel</button>
  <button type="submit" class="btn btn-primary" (click)="update()">Save Account</button>
</div>
